<div class="modal-column" *ngIf="auth.isAuthenticated() && auth.userInfo">
  <!--<div class="signup-left-content">-->
    <!--<h3 class="join-edg-heading">Verify your phone number & get 27 free spins</h3>-->
    <!--<div class="signup-image phone-verification-image"></div>-->
    <!--<div class="licence-wrap">-->
      <!--<img src="/assets/images/v2/register/logos/curacao-logo.png"-->
           <!--alt="" class="curacao-licence _10-spacer">-->
      <!--<span class="casino-text">First licenced crypto casino in the world.</span>-->
    <!--</div>-->


    <!--<div class="signup-value-wrap">-->
      <!--<div class="_20-px-spacer"></div>-->
      <!--<img src="/assets/images/v2/register/logos/mastercard.svg" height="25" class="onboarding-icon">-->
      <!--<img src="/assets/images/v2/register/logos/visa.svg" width="40" class="onboarding-icon">-->
      <!--<img src="/assets/images/v2/register/logos/indacoin.svg" width="30" class="onboarding-icon">-->
      <!--<img src="/assets/images/v2/register/logos/bitcoin.svg" width="50" class="onboarding-icon">-->
      <!--<img src="/assets/images/v2/register/logos/changelly.svg" width="70" class="onboarding-icon">-->
      <!--<img src="/assets/images/v2/register/logos/edgeless.svg" width="60" class="onboarding-icon">-->
      <!--<img src="/assets/images/v2/register/logos/ethereum.svg" width="60" class="onboarding-icon">-->
    <!--</div>-->
  <!--</div>-->
  <div class="form-wrap">
    <ng-container *ngIf="step == 0">
      <form (ngSubmit)="$event.preventDefault();loading = true;captchaRef.execute();" [formGroup]="requestForm" novalidate>
        <!--<p class="popup-paragraph white hide-desktop"><strong>Verify your phone number & get 27 free spins</strong></p>-->
        <p class="popup-paragraph white">Enter your phone number below:</p>
        <!--<p>-->
          <!--Sorry we experiencing some technical issues and phone verification is not available right now.-->
          <!--Please contact support for your bonus or come back and try again some time later.-->
        <!--</p>-->
        <div class="input-wrap">
          <div class="input-labels-wrap">
            <div class="input-label">Prefix</div>
            <div class="input-label prefix-label">Phone number</div>
          </div>
          <div class="confirmation-code-wrap">
            <app-form-input formControlName="prefix"
                            [show-icons]="false"
                            maxlength="5"
                            placeholder="+"
                            class="input-2 input-country-prefix"
                            data-id="phone-prefix"></app-form-input>
            <p class="popup-paragraph">-</p>
            <app-form-input formControlName="number"
                            [show-icons]="false"
                            maxlength="16"
                            class="input-2 phone-number"
                            data-id="phone-number"></app-form-input>
          </div>
        </div>
        <div class="_10-px-spacer"></div>
        <app-form-button type="submit" class="primary full-width" [disabled]="loading || requestForm.invalid"
                         data-id="signup2-submit-buttton">
          Verify
        </app-form-button>

        <div class="resend-confirmation-code">
          <a href="/home" class="resend-code" (click)="skip($event)" data-id="signup2-resend-href">Skip phone verification</a>
        </div>
        <re-captcha #captchaRef="reCaptcha" (resolved)="$event && request($event)"></re-captcha>
      </form>
    </ng-container>
    <ng-container *ngIf="step == 1">
      <form (ngSubmit)="confirm($event)" [formGroup]="confirmForm" novalidate>
        <p class="subtext">Confirmation code was sent to:
          <a href="#" (click)="$event.preventDefault()">{{ phoneNumber }}</a>
        </p>
        <div class="input-wrap">
          <p class="small-text">Your confirmation code</p>
          <div class="confirmation-code-wrap">
            <app-form-input formControlName="code_1" maxlength="1" type="number" [show-icons]="false" class="input-2 confirmation-code" #code1
                            (ngModelChange)="codeChange($event, code2)" data-id="signup2-code1-input"></app-form-input>
            <app-form-input formControlName="code_2" maxlength="1" type="number"  [show-icons]="false" class="input-2 confirmation-code" #code2
                            (ngModelChange)="codeChange($event, code3)" data-id="signup2-code2-input"></app-form-input>
            <app-form-input formControlName="code_3" maxlength="1" type="number" [show-icons]="false" class="input-2 confirmation-code" #code3
                            (ngModelChange)="codeChange($event, code4)" data-id="signup2-code3-input"></app-form-input>
            <app-form-input formControlName="code_4" maxlength="1" type="number" [show-icons]="false" class="input-2 confirmation-code" #code4
                            (ngModelChange)="codeChange($event, code5)" data-id="signup2-code4-input"></app-form-input>
            <app-form-input formControlName="code_5" maxlength="1" type="number" [show-icons]="false" class="input-2 confirmation-code" #code5
                            (ngModelChange)="codeChange($event, code6)" data-id="signup2-code5-input"></app-form-input>
            <app-form-input formControlName="code_6" maxlength="1" type="number" [show-icons]="false" class="input-2 confirmation-code" #code6
                            (ngModelChange)="codeChange($event)" data-id="signup6-code1-input"></app-form-input>
          </div>
        </div>
        <div class="_10-px-spacer"></div>
        <app-form-button type="submit" class="primary full-width" [disabled]="loading || confirmForm.invalid"
                         data-id="signup2-submit-buttton">
          Verify
        </app-form-button>

        <div class="resend-confirmation-code">
          <a href="/home" class="resend-code" (click)="step = 0;$event.preventDefault();cancelVerification($event)"
             data-id="signup2-resend-href">Change phone number</a>
        </div>
      </form>
    </ng-container>
  </div>
  <a href="/home" (click)="skip($event)" class="icon close-popup" data-id="signup2-close-href">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/verify-phone/verify-phone-modal.template.html